import { useRecoilState } from 'recoil'

import atom from 'components/forms/conditionSpecific/state'
import useCsqModelUtils from 'hooks/useCsqModelUtils'

export default () => {

    const [csState, setCsState] = useRecoilState(atom)
    const csqModelUtils = useCsqModelUtils()

    /**
     * initConditionSpecificModel
     *
     * Responsible for preparing the form model when a form loads.
     *
     * Behaviour:
     * - If this is a brand new form → use the latest blank model.
     * - If this is an existing "InProgress" form → reconcile the saved draft with the latest model structure.
     *
     * Why reconciliation is needed:
     * Form schemas can evolve over time (new questions added, new fields introduced).
     * Previously saved drafts may not contain those new fields.
     *
     * syncWithLatestModel ensures:
     * - New fields are injected into older drafts.
     * - Existing user-entered values are preserved.
     * - The resulting model always matches the latest expected structure.
     *
     * This allows schema changes without breaking existing InProgress forms.
     */
    function initConditionSpecificModel(model) {

        // Start with the latest blank template (source of truth)
        let finalModel = model

        // If a draft already exists in state, it means:
        // - The form was previously saved
        // - Data was loaded back from the API
        let savedModel = csState.questions

        if (savedModel) {
            // Reconcile the saved draft with the latest model structure.
            // This acts as a backwards-compatibility layer.
            finalModel = csqModelUtils.syncWithLatestModel(model, savedModel)
        }

        // Persist the prepared model into global state.
        // The form UI will consume this state when rendering.
        setCsState({
            ...csState,
            questions: finalModel
        })
    }

    return {
        initConditionSpecificModel
    }
}